import { render } from "./ClientSpacePurchaseHistory.vue?vue&type=template&id=416501eb&scoped=true"
import script from "./ClientSpacePurchaseHistory.vue?vue&type=script&lang=js"
export * from "./ClientSpacePurchaseHistory.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=416501eb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416501eb"]])

export default __exports__